import { AutocompleteListItem } from "models/propTypes/listPropTypes";
import { useCustomerService } from "serviceHooks";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { LocalizationHelperInstance } from "utils/helpers";

function useCustomerSearch() {
  const customerService = useCustomerService();
  const searchCustomers = async (value: string) => {
    if (value)
      return customerService.searchInternalCustomers(value).then((res) => {
        const options: AutocompleteListItem[] = res.map((item) => ({
          id: item.id ?? 0,
          value: item.name ?? "",
          icon: IconDefinitionConstants.WBuilding,
          group: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Suggestions),
          description: item.orgNr,
          data: item.orgNr,
        }));

        return options;
      });
    else return [];
  };

  return searchCustomers;
}

export default useCustomerSearch;
